<div class="row">
  <div
    *ngIf="consultationTimeLines && consultationTimeLines?.length; else noCase"
    class="container ps-3 px-5 py-3"
  >
    <div class="tab-content tab-content-style" id="myTabContent">
      <div class="tab-pane fade show active" role="tabpanel">
        <div class="segment-area">
          <p class="title text-start fs-6 pt-0 mb-2">
            {{ "cases" | translate }}
          </p>
          <div class="custom-hr">
            <div class="progress-bar"></div>
          </div>
        </div>
        <div class="segment-content mt-2">
          <div class="date-area">
            <div class="case-item">
              <div class="left-side"></div>
              <div class="right-side">
                <div
                  class="timeline-space"
                  *ngFor="let item of timeLineDates"
                  [ngStyle]="{ width: timelineWidth }"
                >
                  <span>{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="timeline-area">
            <div
              class="case-item"
              *ngFor="let case of consultationTimeLines"
              (click)="onSelectTimeline(case)"
              [ngClass]="
                case.patientRecordCaseId ===
                  selectedTimeline?.patientRecordCaseId && !case.cases?.length
                  ? 'selected'
                  : ''
              "
            >
              <div class="left-side">
                <span [ngStyle]="{ color: getTimelineTextColor(case) }"
                  >Case {{ case.patientRecordCaseNumber }}</span
                >
              </div>
              <div class="right-side">
                <div class="timeline-borders-area">
                  <div
                    class="timeline-border"
                    *ngFor="let item of timeLineDates"
                    [ngStyle]="{ width: timelineWidth }"
                  ></div>
                </div>
                <div
                  class="timeline-space"
                  *ngFor="let item of timeLineDates; let i = index"
                  [ngStyle]="{ width: timelineWidth }"
                >
                  <div
                    *ngIf="hasTimelineBall(case, item)"
                    class="timeline-ball"
                    (click)="
                      onSelectTimeline(hasTimelineBall(case, item), $event)
                    "
                    [ngStyle]="{
                      backgroundColor: getTimelineCircleBGColor(case, item)
                    }"
                    [ngClass]="
                      selectedTimeline?.patientRecordCaseId ===
                      hasTimelineBall(case, item)?.patientRecordCaseId
                        ? 'selected'
                        : ''
                    "
                  >
                    <img
                      *ngIf="case.unreadCount == ChatStatus.MessageFromGp"
                      alt="message"
                      class="message"
                      src="./../../../../assets/media/message.png"
                    />
                  </div>
                  <div
                    class="timeline-bar"
                    [ngClass]="getTimelineBarClass(case, i)"
                    [ngStyle]="{ backgroundColor: getTimelineBarBGColor(case) }"
                    *ngIf="hasTimelineBar(case, item)"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="right-side"></div> -->
        </div>
      </div>
    </div>
  </div>
  <ng-template #noCase>
    <div class="no-case-found">
      {{ "noCaseToBeDisplayedHere" | translate }}.
    </div>
  </ng-template>
</div>
